const Todo = ({ color = '#E01E4E' }: { color?: string }) => (
  <svg
    aria-hidden="true"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3876_25553)">
      <path
        d="M9.99967 14.9998C10.2298 14.9998 10.4163 14.8133 10.4163 14.5832C10.4163 14.3531 10.2298 14.1665 9.99967 14.1665C9.76956 14.1665 9.58301 14.3531 9.58301 14.5832C9.58301 14.8133 9.76956 14.9998 9.99967 14.9998Z"
        fill={color}
      />
      <path
        d="M9.99967 19.1666C15.0623 19.1666 19.1663 15.0625 19.1663 9.99992C19.1663 4.93731 15.0623 0.833252 9.99967 0.833252C4.93706 0.833252 0.833008 4.93731 0.833008 9.99992C0.833008 15.0625 4.93706 19.1666 9.99967 19.1666Z"
        fill={color}
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5V11.6667"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99967 14.9998C10.2298 14.9998 10.4163 14.8133 10.4163 14.5832C10.4163 14.3531 10.2298 14.1665 9.99967 14.1665C9.76956 14.1665 9.58301 14.3531 9.58301 14.5832C9.58301 14.8133 9.76956 14.9998 9.99967 14.9998Z"
        fill="white"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3876_25553">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Todo
